const DOMAIN_TYPE = 'Compliance';

module.exports = {
  DOMAIN_TYPE,
};
